import { ReactNode } from 'react';
import { Typography } from '@mui/material';

export const SectionLabel = ({ children }: { children: ReactNode }) => (
  <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: '0.08em', fontWeight: 700 }}>
    {children}
  </Typography>
);

export default SectionLabel;
